import React, { useState, useEffect, useCallback } from "react";
import { Pagination, Row, Col, Collapse, Button, Modal, message } from "antd";
import axios from "axios";
import PageHeader from "../Layout/PageHeader";
import UserAuditLogsFilters from "./UserAuditLogsFilters";
import { CaretRightOutlined, DownloadOutlined } from "@ant-design/icons";
import UserAuditLogItem from "./UserAuditLogItem";

const UserAuditLogs = () => {
  const [pagination, setPagination] = useState({
    currentPage: 1,
    limit: 10,
  });
  const [userAuditLogs, setUserAuditLogs] = useState([]);
  const [filters, setFilters] = useState({
    email: null,
    description: null,
    startDate: null,
    endDate: null
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadCSV = async () => {
    setIsDownloading(true);

    const messageContent = (
      <p>
        Are you sure you want to download {pagination?.totalSize} User logs data ?<br />
      </p>
    );

    const params = {
      ...(filters.email !== null && { email: filters.email }),
      ...(filters.description !== null && { description: filters.description }),
      ...(filters.startDate && {
        startDate: filters.startDate?.startOf("day")?.toISOString(),
      }),
      ...(filters.endDate && {
        endDate: filters.endDate?.endOf("day")?.toISOString(),
      }),
      limit: pagination.limit,
      page: pagination.currentPage,
    };

    Modal.confirm({
      content: messageContent,
      title: `Download User Audit Log List ? `,
      async onOk() {
        await axios
          .get("api/user-logs/csv", { params })
          .then((res) => {
            message.info(`Please check the Export progress in System -> Jobs`);
          })
          .catch((error) => {
            message.error(error.message);
          });
      },
    });

    setIsDownloading(false);
  };

  const fetchUserAuditLog = useCallback(async () => {
    setIsLoading(true);

    const params = {
      ...(filters.email !== null && { email: filters.email }),
      ...(filters.description !== null && { description: filters.description }),
      ...(filters.startDate && {
        startDate: filters.startDate?.startOf("day")?.toISOString(),
      }),
      ...(filters.endDate && {
        endDate: filters.endDate?.endOf("day")?.toISOString(),
      }),
      limit: pagination.limit,
      page: pagination.currentPage,
    };

    const res = await axios.get("api/user-logs", { params });

    setUserAuditLogs(res.data.data);
    setPagination((prev) => ({
      ...prev,
      totalSize: res.data.pagination?.totalSize,
    }));
    setIsLoading(false);
  }, [pagination.currentPage, pagination.limit, filters]);

  useEffect(() => {
    fetchUserAuditLog();
  }, [pagination.currentPage, pagination.limit, filters]);

  return (
    <div>
      <PageHeader
        title="User Audit Logs"
        childRoutes={[
          { path: "/user-audit-logs", breadcrumbName: "UserAuditLogs" },
        ]}
      />

      <Collapse
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rotate={isActive ? 90 : 0} />
        )}
      >
        <Collapse.Panel header="Filters" key="filters">
          <UserAuditLogsFilters
            filters={filters}
            onFiltersChange={(filters) => setFilters(filters)}
          />
        </Collapse.Panel>
      </Collapse>

      <Row justify="end">
        <Col>
          <Pagination
            total={pagination?.totalSize}
            onChange={(currentPage, limit) => {
              console.log(currentPage, limit, pagination);
              setPagination({ ...pagination, limit, currentPage });
            }}
          />
        </Col>
      </Row>

      <Button onClick={downloadCSV} loading={isDownloading}>
        CSV <DownloadOutlined />
      </Button>

      <UserAuditLogItem loading={isLoading} auditLog={userAuditLogs} />

      <Row justify="end">
        <Col>
          <Pagination
            total={pagination?.totalSize}
            onChange={(currentPage, limit) => {
              setPagination({ ...pagination, limit, currentPage });
            }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default UserAuditLogs;
